
import request from '../request';

// 中文简历-工作经历-贴士等下拉框接口
export const getWorkExamples = (token, params) => {
  return request({
    url: `/v3/cvs/${token}/work_examples`,
    method: 'get',
    params
  });
}

// 获取大牛经历 tag
export const getDaniuTags = () => {
  return request({
    url: `/v3/sample_cv_tags`,
    method: 'get'
  })
}

// 获取其他模块-技能 tag
export const getCvProfessionSkills = (cv_token) => {
  return request({
    url: `/v3/cvs/${cv_token}/profession_skills`,
    method: 'get',
    params: {},
  })
}
